import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/intimate-relationship',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-IntimateRelationship-home" */ '~/pages/IntimateRelationship/pages/home'
        )
    ),
  },
  {
    path: '/intimate-relationship/invite',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-IntimateRelationship-invite" */ '~/pages/IntimateRelationship/pages/Invite'
        )
    ),
  },
  {
    path: '/intimate-relationship/levelUp',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-IntimateRelationship-levelUp" */ '~/pages/IntimateRelationship/pages/levelUp'
        )
    ),
  },
  {
    path: '/intimate-relationship/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-IntimateRelationship-rule" */ '~/pages/IntimateRelationship/pages/rule'
        )
    ),
  },
] as RouteConfig[]
